module.exports = __webpack_public_path__ + "bnbproject/img/link2.670a81fd.png";